import React, { useEffect } from 'react'
import { Switch } from 'react-router-dom'

import Route from './Route'

import BemVindo from '../pages/BemVindo'
import Contribution from '../pages/Contribution'
import ContributionValues from '../pages/ContributionValues'
import Simulation from '../pages/Simulation'
import Benefit from '../pages/Benefit'
import Register from '../pages/Register'
import ConfirmSMS from '../pages/ConfirmSMS'
import Taxation from '../pages/Taxation'
import InvestorQuiz from '../pages/InvestorQuiz'
import Investor from '../pages/Investor'
import NovoParticipante from '../pages/NovoParticipante'
import ParticipantsList from '../pages/ParticipantsList'
import Fatca from '../pages/Fatca'
import Resume from '../pages/Resume'
import Conclusion from '../pages/Conclusion'
import End from '../pages/End'
import Erro from '../pages/Erro'
import NotFound from '../pages/NotFound'

import usePersistedState from '../hooks/usePersistedState'
import clientConfig from '../services/clientConfig'
import { ConfigData } from '../utils/interfaces'

// import Login from '../pages/Login'
// import GoalSelection from '../pages/GoalSelection'
// import ConfirmOwnership from '../pages/ConfirmOwnership'
// import Help from '../pages/Help'
// import Terms from '../pages/Terms'
// import PersonalInfos from '../pages/PersonalInfos'

const Routes: React.FC = () => {
  const { codCliente, tipo, plano } = clientConfig()

  const [configData, setConfigData] = usePersistedState<ConfigData>(
    'configData',
    {} as ConfigData,
  )
  useEffect(() => {
    setConfigData({
      ...configData,
      codCliente,
      tipo,
      plano,
    })
  }, [])

  return (
    <Switch>
      <Route path="/" exact component={BemVindo} />
      <Route path="/contribution" component={Contribution} />

      <Route path="/contribution-values" component={ContributionValues} />
      <Route path="/simulation" component={Simulation} />
      <Route path="/benefit" component={Benefit} />

      <Route path="/register" exact component={Register} />
      <Route path="/register/confirm-sms" component={ConfirmSMS} />
      <Route path="/taxation" component={Taxation} />
      <Route path="/investor-quiz" component={InvestorQuiz} />
      <Route path="/investor" component={Investor} />
      <Route path="/new-participant" component={NovoParticipante} />
      <Route path="/participants-list" component={ParticipantsList} />
      <Route path="/fatca" component={Fatca} />
      <Route path="/resume" component={Resume} />
      <Route path="/conclusion" component={Conclusion} />
      <Route path="/end" component={End} />
      <Route path="/erro" component={Erro} />
      <Route path="*" component={NotFound} />

      {/* <Route path="/goal-selection" component={GoalSelection} />
      <Route path="/personal-infos" component={PersonalInfos} />
      <Route path="/help" component={Help} />
      <Route path="/confirm-ownership" component={ConfirmOwnership} />
      <Route path="/terms" component={Terms} />
      <Route path="/login" component={Login} /> */}
    </Switch>
  )
}

export default Routes
